<template>
  <div class="SuffixInput temr">
    <div class="input_box">
      <div class="inputShell">
        <div class="inputBox">
          <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
          <div class="inputItem">
            <input
              class="inputContainer"
              :disabled="params.disabled"
              :placeholder="params.props.placeholder"
              :maxLength="params.props.maxLength"
              @input="changeInput"
              v-model="value"
              type="text"
            />
            <div class="error" :style="{ color: 'red' }" v-if="message.message && value !==''">{{ message.message }}</div>
          </div>
        </div>

        <svg
          v-if="!params.disabled && allowClearHandler && value"
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="close"
          width="1em"
          height="1em"
          fill="currentColor"
          class="allowClear"
          aria-hidden="true"
          @click="allowClear"
        >
          <path
            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3
        5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4
        512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3
        3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
          ></path>
        </svg>
      </div>
      <span class="end">{{ params.props.suffixName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuffixInput',
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  data() {
    return {
      error: '',
      isDelete: false,
      message: {
        field: 'loanAmount',
        message: '',
      },
      value: '',
      maxLength: 0,
    };
  },
  computed: {
    maxlength() {
      return this.params.props.max.toString().length;
    },
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.message.message = val.message;
      },
    },
  },
  methods: {
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      if (this.params.props.suffixName === '元') {
        this.value = val.target.value.replace(/[^0-9.]/g, '');
      } else {
        this.value = val.target.value.replace(/[^0-9]/g, '');
      }
      this.$emit('input', this.value);
    },
    clickDelete() {
      this.value = '';
    },
  },
};
</script>
<style scoped lang="scss">
.SuffixInput {
  position: relative;
  background: #fff;
  padding-right: 16px;
}
.input_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.input_box .inputShell {
  flex: 1;
}
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  flex: 1;
  padding: 0;
  width: 100px;
}
.allowClear {
  font-size: 14px;
  color: #999;
  position: absolute;
  right: 38px;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.end {
  position: absolute;
  right: 16px;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -11px;
    }
  }
}
.error {
  font-size: 12px;
}
.title {
  margin-right: 16px;
  font-size: 14px;
  color: #46494D;
  text-align: left;
  font-weight: 400;
  word-wrap: break-word;
  width: 86px;
}
input::-webkit-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-moz-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-ms-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
